export default "__VITE_ASSET__C30SF44M__"